import WorkOrderJobForm from '@/models/jobs/work-orders/WorkOrderJobForm'
import type { TWorkOrdersState } from '@/types/state-types'

export default <TWorkOrdersState>{
  workOrderForm: new WorkOrderJobForm(),
  isWorkOrderLoading: false
}
